import { __rest } from "tslib";
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { tv } from 'tailwind-variants';
import { textSizeStyles, textWeightStyles } from './BtwText';
import { Pin } from './Pin';
const editableText = tv({
    base: [
        'appearance-none',
        'bg-transparent',
        'block',
        'box-border',
        'flex-1',
        'ring-2',
        'ring-transparent',
        'border-2',
        'border-white',
        'select-none',
        'rounded-md',
        'resize-none',
        // Typography
        'font-regular',
        'text-ellipsis',
        'tracking-normal',
        // Transition
        'duration-300',
        'ease-smooth',
        'transition-combined',
        // Color
        'text-gray-900',
        'placeholder-gray-600/40',
        'focus:outline-none',
    ],
    variants: {
        size: textSizeStyles,
        weight: textWeightStyles,
        color: {
            amber: ['ring-amber-300'],
            blue: ['ring-blue-300'],
            pink: ['ring-pink-300'],
            purple: ['ring-purple-300'],
            default: ['focus:ring-gray-600/40', 'hover:ring-gray-600/20'],
        },
    },
    defaultVariants: {
        color: 'default',
    },
});
const pin = tv({
    base: ['[&>div]:rounded-br-md'],
    variants: {
        color: {
            amber: ['[&>div]:bg-amber-300', '[&>div>span]:ring-amber-300'],
            blue: ['[&>div]:bg-blue-300', '[&>div>span]:ring-blue-300'],
            pink: ['[&>div]:bg-pink-300', '[&>div>span]:ring-pink-300'],
            purple: ['[&>div]:bg-purple-300', '[&>div>span]:ring-purple-300'],
            default: [],
        },
    },
    defaultVariants: {
        color: 'default',
    },
});
function EditableText(props) {
    const { className, color, size, weight, realtimeAvatars } = props, rest = __rest(props, ["className", "color", "size", "weight", "realtimeAvatars"]);
    return (React.createElement("div", { className: "relative w-full" },
        React.createElement(TextareaAutosize, Object.assign({ className: editableText({ className, color, size, weight }) }, rest)),
        realtimeAvatars && (React.createElement(Pin.Br, { className: pin({ color }) }, realtimeAvatars))));
}
export { EditableText };
